import React from "react";
import { graphql } from "gatsby"
import Block from "../../Block";
import VideoThumbnail from "components/common/VideoThumbnail";

class UAGBFaq extends Block {
  render() {
    const { block } = this.props;

    return null;
  }
}

class UAGBFaqFactory {
  get type() {
    return "uagb/faq";
  }

  create(props) {
    return <UAGBFaq {...props} />;
  }
}

export default UAGBFaqFactory;
